import { gql } from "@apollo/client"

export const RESET_PASSWORD_MUTATION = gql`
    mutation ResetPasswordMutation($email: String = "") {
        resetPassword(email: $email) {
            ok
        }
    }
`
